import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
var MainContext = /*#__PURE__*/React.createContext();

var MainContextProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(MainContextProvider, _React$Component);

  var _super = _createSuper(MainContextProvider);

  function MainContextProvider(props) {
    var _this;

    _classCallCheck(this, MainContextProvider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setUserId", function (userId) {
      _this.setState({
        userId: userId
      });
    });

    _this.state = {
      userId: null
    };
    return _this;
  }

  _createClass(MainContextProvider, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(MainContext.Provider, {
        value: {
          userId: this.state.userId,
          setUserId: this.setUserId
        }
      }, this.props.children);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MainContextProvider;
}(React.Component);

var withMain = function withMain(Component) {
  return function WrapperComponent(props) {
    return /*#__PURE__*/React.createElement(MainContext.Consumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
    });
  };
};

export { MainContext, MainContextProvider, withMain };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MainContext, "MainContext", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/MainContext.js");
  reactHotLoader.register(MainContextProvider, "MainContextProvider", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/MainContext.js");
  reactHotLoader.register(withMain, "withMain", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/MainContext.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();